

export const Work = [
    {
        id:1,
        name:"Cryptobucks",
        description:" Cryptobucks is a project that aims to provide users with daily updates on the prices of various cryptocurrencies.",
        tags:["HTML", "Css", "JavaScript", "React", "GSAP", "SaSS", "TAILWIND"],
        
         demo:"https://cryptobuck.vercel.app",
         github:"https://github.com/777irug/CRYPTOBUCKS"
    },
    {
        id:2,
        name:"Apple Landing Page",
        description:"The Apple Landing Page project aims to create a visually stunning and engaging web page that showcases Apple's latest products.",
        tags:["HTML", "Css", "JavaScript", "React", "GSAP", "SaSS", "TAILWIND"],
        
         demo:"https://apple-by-gursimranjit.vercel.app/",
         github:"https://github.com/777irug/apple-landing-page-by-Gursimranjit"
        
    },
    {
        id:3,
        name:"Elan-Studio",
        description:"Elan-Studio is a sleek and modern salon website that provides users with a sophisticated and luxurious online experience.",
        tags:["HTML", "Css", "JavaScript", "React", "API", "SaSS", "TAILWIND"],
        
        demo:"https://elan.vercel.app/",
        github:"https://github.com/777irug/elanstudio"
    },
    // {
    //     id:4,
    //     name:"Sidebar Menu",
    //     description:"A cool looking sidebar menu build using ReactJS and styledComponents.It has really smooth animations.",
    //     tags:["react","styledComponents","react-router"],
        
    //     // demo:"https://react-sidebar.vercel.app/",
    //     // github:"https://github.com/codebucks27/react-sidebar"
       
    // },{
    //     id:5,
    //     name:"Todo App(React + Redux)",
    //     description:"A todo app build using Redux-toolkit and framer-motion for smooth animations.",
    //     tags:["react","redux","framer-motion"],
        
    //     // demo:"http://react-redux-todo-app-git-main-codebucks27.vercel.app/",
    //     // github:"https://github.com/codebucks27/React-Redux-Todo-App"
        
    // },
    // {
    //     id:6,
    //     name:"Responsive Navigation Menu",
    //     description:"A reponsive navbar menu component in ReactJS with react-router functionalities. Built from scratch.",
    //     tags:["react","react-router","css"],
        
    //     // demo:"http://react-responsive-navbar-codebucks27.vercel.app/",
    //     // github:"https://github.com/codebucks27/React-responsive-navbar"
        
    // },
    
  
] 